import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择琪琪影院
          </h2>
          <p className="text-sm text-foreground-500 mt-2">五大核心优势，打造极致追剧体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center hover:border-primary-200 transition-colors cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${item.icon} text-xl`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}